module.exports = __webpack_public_path__ + "img/mht.2ae34b3d.jpg";